import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import TextField from '@material-ui/core/TextField';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { observer } from 'mobx-react';
import * as React from 'react';
import { stylesheet } from "typestyle";
import { Logger, SensorType } from './Models';

const css = stylesheet({
	container: {
		display: 'flex',
		flexDirection: 'column',
		padding: '10px',
	},
	root: {
		height: 'initial',
		width: 'initial',
	},
	settings: {
		opacity: .5,
	},
	textField: {
		width: '200px',
	},
})

@observer
export default class OxygenLoggerSettings extends React.Component<{
	logger: Logger,
}>{

	state = {
		anchorEl: null,
		calibrationText: 'Calibrate',
		pin: '',
	};

	handleClick = (event: React.FormEvent) => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleCalibrate = () => {
		if (this.state.calibrationText === 'Calibrating...' || this.state.pin === '') {
			return
		}
		this.setState({ calibrationText: 'Calibrating...' })
		this.props.logger.calibrate(this.state.pin, SensorType.OXYGEN)
			.then(() => {
				this.setState({ calibrationText: 'Success...' })
				setTimeout(() => {
					this.setState({ anchorEl: null, calibrationText: 'Calibrate', pin: '' })
				}, 800)
			})
			.catch(() => {
				this.setState({ calibrationText: 'Failed...' })
				setTimeout(() => {
					this.setState({ calibrationText: 'Calibrate' })
				}, 800)
			})
	};

	handleClose = () => {
		this.setState({
			anchorEl: null,
		});
	};

	handlePinChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({
			pin: event.target.value,
		});
	};

	render() {
		const { anchorEl, calibrationText, pin } = this.state;

		return (
			<div>
				<IconButton
					className={css.root}
					aria-haspopup="true"
					onClick={this.handleClick}>
					<MoreVertIcon className={css.settings} />
				</IconButton>

				<Popover
					open={Boolean(anchorEl)}
					anchorEl={anchorEl}
					onClose={this.handleClose}
					anchorOrigin={{
						horizontal: 'left',
						vertical: 'top',
					}}
					transformOrigin={{
						horizontal: 'left',
						vertical: 'top',
					}}
				>
					<div className={css.container}>
						<TextField
							id="password-input"
							label="PIN"
							className={css.textField}
							type="password"
							autoComplete="current-password"
							margin="normal"
							onChange={this.handlePinChange}
							disabled={calibrationText !== 'Calibrate'}
						/>
						<Button disabled={pin === '' || calibrationText !== 'Calibrate'} onClick={this.handleCalibrate}>
							{calibrationText}
						</Button>
					</div>
				</Popover>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/OxygenLoggerSettings.tsx